import { Controller } from "@hotwired/stimulus"

// テキストエリアのバリデーションと入力文字数のカウント
// 設置例
//   <div data-controller="validator--textarea-counter">
//     <p>1000文字まで入力できます：あと<span class="fw-bold" data-validator--textarea-counter-target="counter">30</span>文字</p>
//     <textarea data-limit="1000" data-action="validator--textarea-counter#checkTextarea" data-count-type="down"></textarea>
//   </div>
//     - data-limit="1000" 最大文字数を指定
//     - data-count-type="down" 入力可能な残り文字数を表示する場合は "down"、現在の入力文字数を表示する場合は "up" を指定

// Connects to data-controller="validator--textarea-counter"
export default class extends Controller {
  static targets = [
    "counter"
  ];

  static values = {
    countType: String
  };

  // 型定義
  declare readonly counterTarget: HTMLElement;
  declare readonly countTypeValue: string;

  connect(): void {
    this.initUpdateTextCount();
  }

  initUpdateTextCount(): void {
    const selector = '[data-action="validator--textarea-counter#checkTextarea"]';
    const textArea = this.element.querySelector<HTMLTextAreaElement>(selector);
    if (textArea) {
      this.updateTextCount(textArea);
    }
  }

  checkTextarea(event: Event): void {
    this.updateTextCount(event.target as HTMLTextAreaElement);
  }

  updateTextCount(element: HTMLTextAreaElement): void {
    const countType = element.dataset.countType;
    if (countType == null) console.error('countType is not set');

    // 最大文字数
    const limitNum = Number(element.dataset.limit);
    if (isNaN(limitNum)) console.error('Maximum character limit is not set');

    // 入力された文字数
    const normalized: string = element.value.replace(/\r\n/g, "\n")
    const inputCount: number = Array.from(normalized).length

    // カウントアップ表示
    if (countType == 'up') {
      this.counterTarget.textContent = inputCount.toString();
      if (inputCount > limitNum) {
        this.displayWarning(element as HTMLTextAreaElement);
      } else {
        this.displayNormal(element as HTMLTextAreaElement);
      }

    // カウントダウン表示
    } else if (countType == 'down') {
      const counter = limitNum - inputCount;
      this.counterTarget.textContent = counter.toString();
      if (counter < 10) {
        this.displayWarning(element as HTMLTextAreaElement);
      } else {
        this.displayNormal(element as HTMLTextAreaElement);
      }
    }
  }

  displayWarning(element: HTMLTextAreaElement): void {
    this.counterTarget.style.color = "#e00000";
    this.counterTarget.style.fontWeight = "bold";
  }

  displayNormal(element: HTMLTextAreaElement): void {
    this.counterTarget.style.color = "#000000";
    this.counterTarget.style.fontWeight = "normal";
  }
}
